const SIGNUP_PATHS = ['/signup', '/agencysignup', '/panasonicmdt', '/reasonsweserve'];

/** The tag posts each page's URL and title to LinkedIn, so it must never run where those name videos or libraries. */
export const isLinkedInPage = (path: string) =>
  SIGNUP_PATHS.some(page => path === page || path.startsWith(`${page}/`));

export const createInitScript = (id: string): Node => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.text = `
    _linkedin_partner_id = ${id};
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  `
  return script;
}

export const createAsyncScript = (s: Node): Node => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- LinkedIn tracking pixel requires extending the global window object
  const w = window as any;
  const script = document.createElement('script');
  script.type = 'text/javascript';

  script.onload = (function (l: unknown) {
    if (!l) {
      w.lintrk = function (a: unknown, b: unknown) { w.lintrk.q.push([a, b]) };
      w.lintrk.q = []
    }
    const b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode?.insertBefore(b, s);

    return null;
  })(w.lintrk);

  return script;
}

export const createNoScriptPixel = (id: string): Node => {
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.alt = '';
  img.src = `https://px.ads.linkedin.com/collect/?pid=${id}&fmt=gif`;
  noscript.appendChild(img);

  return noscript;
}